import { useState } from "react";
import { deleteRoute, readRouteDeleteConflict } from "../../services";
import { RouteManagementRow } from "../../types/route.type";
import ConfirmModal from "../ConfirmModal";
import { buildRouteInUseMessage } from "./routeText";

interface DeleteRouteDialogProps {
  /** The route being asked about; null keeps the dialog closed. */
  target: RouteManagementRow | null;
  onClose: () => void;
  onDeleted: () => void;
  /** The API refused: stores or sales staff were tied to the route after the list loaded. */
  onRefused: (message: string) => void;
}

export default function DeleteRouteDialog({
  target,
  onClose,
  onDeleted,
  onRefused,
}: DeleteRouteDialogProps) {
  const [deleting, setDeleting] = useState<boolean>(false);

  const removeRoute = async (route: RouteManagementRow) => {
    try {
      await deleteRoute(route.uuid);
      onDeleted();
    } catch (error) {
      // The interceptor already toasted the failure; a 409 carries the counts that block the
      // delete, which the page keeps on screen after the dialog closes.
      const conflict = readRouteDeleteConflict(error);
      if (conflict) onRefused(buildRouteInUseMessage(route.route_code, conflict));
    }
  };

  const handleConfirm = async () => {
    if (!target) return;
    setDeleting(true);
    await removeRoute(target);
    setDeleting(false);
    onClose();
  };

  const handleClose = () => {
    if (deleting) return;
    onClose();
  };

  return (
    <ConfirmModal
      open={Boolean(target)}
      title={`ลบสาย ${target?.route_code ?? ""} ${target?.route_name ?? ""}`}
      description="สายที่ลบจะไม่แสดงในระบบอีก ถ้าสร้างเลขสายเดิมใหม่ภายหลัง ระบบจะนำสายนี้กลับมา และประวัติบิลของรหัสสายนี้ยังต่อกันเหมือนเดิม"
      confirmLabel="ลบสาย"
      confirmColor="error"
      loading={deleting}
      onClose={handleClose}
      onConfirm={handleConfirm}
    />
  );
}
